import React from 'react';
interface HeroSectionProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  buttonText?: string;
  buttonLink?: string;
  overlay?: boolean;
  size?: 'small' | 'medium' | 'large';
  alignment?: 'left' | 'center' | 'right';
}
const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  backgroundImage = 'https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  buttonText,
  buttonLink,
  overlay = true,
  size = 'large',
  alignment = 'center'
}) => {
  const getHeightClass = () => {
    switch (size) {
      case 'small':
        return 'h-[300px] md:h-[400px]';
      case 'medium':
        return 'h-[400px] md:h-[500px]';
      case 'large':
        return 'h-[500px] md:h-[600px]';
      default:
        return 'h-[500px] md:h-[600px]';
    }
  };
  const getAlignmentClass = () => {
    switch (alignment) {
      case 'left':
        return 'text-left items-start';
      case 'right':
        return 'text-right items-end';
      default:
        return 'text-center items-center';
    }
  };
  return <div className={`relative w-full ${getHeightClass()} flex items-center justify-center bg-cover bg-center bg-no-repeat overflow-hidden`} style={{
    backgroundImage: `url(${backgroundImage})`
  }} data-id="element-154">
      {overlay && <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-secondary-600/90" data-id="element-155"></div>}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-156">
        <div className={`flex flex-col ${getAlignmentClass()} max-w-3xl mx-auto animate-fade-in`} data-id="element-157">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 drop-shadow-lg" data-id="element-158">
            {title}
          </h1>
          {subtitle && <p className="text-xl md:text-2xl text-white opacity-90 mb-8 drop-shadow-md" data-id="element-159">
              {subtitle}
            </p>}
          {buttonText && buttonLink && <div data-id="element-160">
              <a href={buttonLink} className="inline-block bg-white text-primary-600 font-medium py-3 px-6 rounded-md transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl" data-id="element-161">
                {buttonText}
              </a>
            </div>}
        </div>
      </div>
    </div>;
};
export default HeroSection;